import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FVFunil } from 'src/app/models/fvfunil';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmService } from '../../services/crm/crm.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-funil-modal',
  templateUrl: './funil-modal.component.html',
  styleUrls: ['./funil-modal.component.scss']
})
export class FunilModalComponent implements OnInit {

  funis: FVFunil[] = [];
  funilSelecionado;
  public config: PerfectScrollbarConfigInterface = {};

  // construtor
  constructor(public dialogRef: MatDialogRef<FunilModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService,
    private crmService: CrmService, private carregandoService: CarregandoService
  ) { }

  ngOnInit() {
    this.funilSelecionado = this.data.funilSelecionado;
    this.buscarFunis();
  }

  salvar() {

    this.dialogRef.close(this.funilSelecionado);

  }

  fechar() {
    this.dialogRef.close();
  }



  buscarFunis() {
    this.carregandoService.mostra('buscaFunis');

    this.crmService.consultarCRM().subscribe(resp => {
      this.funis = resp;
      if (this.funis && this.funis.length > 0) {
        if (!this.funilSelecionado) {
          this.funilSelecionado = this.funis[0].id;
        }

      }
      this.carregandoService.esconde('buscaFunis');
    }, (erro) => {
      this.carregandoService.esconde('buscaFunis');
      this.notificacaoService.erro(erro);
    });
  }

}
